import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicyPage.scss'

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="privacy-policy-page">
      <h1>Privacy Policy</h1>
      <p>Last updated: September, 8, 2024</p>
      
      <section>
        <h2>1. Introduction</h2>
        <p>Kitchen9 ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website, mobile application, and AI-powered recipe generation services (collectively, the "Service").</p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <h3>2.1 Personal Information</h3>
        <p>We may collect personally identifiable information, such as:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Dietary preferences and restrictions</li>
          <li>User-generated content (recipes, comments, ratings)</li>
        </ul>

        <h3>2.2 Non-Personal Information</h3>
        <p>We may also collect non-personal information, including:</p>
        <ul>
          <li>Browser type</li>
          <li>Device type</li>
          <li>Operating system</li>
          <li>IP address</li>
          <li>Usage data (e.g., pages visited, time spent on the Service)</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Collect Information</h2>
        <p>We collect information through:</p>
        <ul>
          <li>Direct interactions (e.g., creating an account, submitting recipes)</li>
          <li>Automated technologies (e.g., cookies, web beacons)</li>
          <li>Third-party sources (e.g., social media platforms, if you choose to link your account)</li>
        </ul>
      </section>

      <section>
        <h2>4. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide and maintain our Service</li>
          <li>Personalize your experience (e.g., generate tailored recipes)</li>
          <li>Improve our Service</li>
          <li>Communicate with you</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section>
        <h2>5. Sharing Your Information</h2>
        <p>We may share your information with:</p>
        <ul>
          <li>Service providers (e.g., hosting, analytics)</li>
          <li>Legal and regulatory authorities</li>
          <li>Other users (for user-generated content you choose to make public)</li>
        </ul>
        <p>We do not sell your personal information to third parties.</p>
      </section>

      <section>
        <h2>6. Data Security</h2>
        <p>We implement appropriate technical and organizational measures to protect your information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
      </section>

      <section>
        <h2>7. Your Data Protection Rights</h2>
        <p>Depending on your location, you may have the following rights:</p>
        <ul>
          <li>Access to your personal information</li>
          <li>Correction of inaccurate information</li>
          <li>Deletion of your information</li>
          <li>Restriction of processing</li>
          <li>Data portability</li>
          <li>Objection to processing</li>
        </ul>
        <p>To exercise these rights, please <Link to="/contact">contact us</Link>.</p>
      </section>

      <section>
        <h2>8. Children's Privacy</h2>
        <p>Our Service is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.</p>
      </section>

      <section>
        <h2>9. Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
      </section>

      <section>
        <h2>10. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please <Link to="/contact">contact us</Link>.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;